class FnDomLibrary {
  nodes: Array<any> = [];
  private rnothtmlwhite = (/[^\x20\t\r\n\f]+/g);

  init(parameter: any, context?: any): any {
    if (!(this instanceof FnDomLibrary)) {
      return new FnDomLibrary().init(parameter, context);
    }
    if (parameter instanceof FnDomLibrary) {
      return parameter;
    }

    if (typeof parameter === 'string') {
      parameter = this.select(parameter, context);
    }

    // If we're referring a specific node as in on('click', function(){ u(this) })
    // or the select() function returned a single node such as in '#id'
    if (parameter && parameter.nodeName) {
      parameter = [parameter];
    }

    // Convert to an array, since there are many 'array-like' stuff in js-land
    this.nodes = this.slice(parameter);
    return this;

  }

  select = (parameter: any, context: any) => {
    // Allow for spaces before or after
    parameter = parameter.replace(/^\s*/, '').replace(/\s*$/, '');

    if (/^</.test(parameter)) {
      return this.generate(parameter);
    }

    return (context || document).querySelectorAll(parameter);
  }

  slice = (pseudo: any) => {
    // Check that it's not a valid object
    if (!pseudo || pseudo.length === 0 ||
      typeof pseudo === 'string' ||
      pseudo.toString() === '[object Function]') {
      return [];
    }

    // Accept also a u() object (that has .nodes)
    return pseudo.length ? [].slice.call(pseudo.nodes || pseudo) : [pseudo];
  }

  generate = (html: any) => {
    // Table elements need to be child of <table> for some f***ed up reason

    if (/^\s*<tr[> ]/.test(html)) {
      return new FnDomLibrary().init(document.createElement('table')).html(html).children().children().nodes;
    } else if (/^\s*<t(h|d)[> ]/.test(html)) {
      return new FnDomLibrary().init(document.createElement('table')).html(html).children().children().children().nodes;
    } else if (/^\s*</.test(html)) {
      return new FnDomLibrary().init(document.createElement('div')).html(html).children().nodes;
    } else {
      return document.createTextNode(html);
    }
  }

  html = (text: any) => {
    // Needs to check undefined as it might be ""
    if (text === undefined) {
      return this.first().innerHTML || '';
    }

    // If we're attempting to set some text
    // Loop through all the nodes
    return this.each((node: any) => {
      // Set the inner html to the node
      node.innerHTML = text;
    });
  }

  first = () => {
    return this.nodes[0] || false;
  }
  // tslint:disable-next-line: ban-types
  each = (callback: Function) => {
    if (!callback || typeof callback !== 'function') {
      return;
    }
    for (let i = 0; i < this.nodes.length; i++) {
      callback(this.nodes[i], i);
    }

  }
  empty = () => {
    return this.each((node: any) => {
      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }
    });
  }


  // .filter(selector)
  // Delete all of the nodes that don't pass the selector
  filter = (selector: any, isNative?: boolean) => {
    // The default function if it's a CSS selector
    // Cannot change name to 'selector' since it'd mess with it inside this fn
    let callback = (node: any) => {
      // Make it compatible with some other browsers
      node.matches = node.matches || node.msMatchesSelector || node.webkitMatchesSelector;

      // Check if it's the same element (or any element if no selector was passed)
      return node.matches(selector || '*');
    };

    // filter() receives a function as in .filter(e => u(e).children().length)
    if (typeof selector === 'function') {
      callback = selector;
    }

    // filter() receives an instance of Agis as in .filter(u('a'))
    if (selector instanceof FnDomLibrary) {
      callback = (node) => {
        return (selector.nodes).indexOf(node) !== -1;
      };
    }

    return isNative ? this.nodes.filter(callback) : new FnDomLibrary().init(this.nodes.filter(callback));
  }

  // Find all the nodes children of the current ones matched by a selector
  find = (selector: any) => {
    return this.map((node: any) => {
      return new FnDomLibrary().init(selector || '*', node);
    });
  }
  // tslint:disable-next-line: ban-types
  map = (callback: Function) => {
    return callback ? new FnDomLibrary().init(this.array(callback)).unique() : this;
  }
  // Merge all of the nodes that the callback return into a simple array
  // tslint:disable-next-line: ban-types
  array = (callback: Function) => {
    callback = callback;
    const self = this;
    return this.nodes.reduce((list, node, i) => {
      let val;
      if (callback) {
        val = callback.call(self, node, i);
        if (!val) {
          val = false;
        }
        if (typeof val === 'string') {
          val = new FnDomLibrary().init(val);
        }
        if (val instanceof FnDomLibrary) {
          val = val.nodes;
        }
      } else {
        val = node.innerHTML;
      }
      return list.concat(val !== false ? val : []);
    }, []);
  }


  // Removed duplicated nodes, used for some specific methods
  unique = () => {
    return new FnDomLibrary().init(this.nodes.reduce((clean, node) => {
      const istruthy = node !== null && node !== undefined && node !== false;
      return (istruthy && clean.indexOf(node) === -1) ? clean.concat(node) : clean;
    }, []));
  }

  classesToArray = (val: any) => {
    if (Array.isArray(val)) {
      return val;
    }
    if (typeof val === 'string') {
      return val.match(this.rnothtmlwhite) || [];
    }
    return [];
  }

  // Add class(es) to the matched nodes
  addClass = (value: any) => {
    let classes: Array<any>;
    let elem;
    let cur;
    let curValue: string;
    let clazz;
    let j;
    let finalValue;
    let i = 0;

    classes = this.classesToArray(value);

    if (classes.length) {
      // tslint:disable-next-line: no-conditional-assignment
      while ((elem = this.nodes[i++])) {
        curValue = this.getClass(elem);
        cur = elem.nodeType === 1 && (' ' + this.stripAndCollapse(curValue) + ' ');

        if (cur) {
          j = 0;
          // tslint:disable-next-line: no-conditional-assignment
          while ((clazz = classes[j++])) {
            if (cur.indexOf(' ' + clazz + ' ') < 0) {
              cur += clazz + ' ';
            }
          }

          // Only assign if different to avoid unneeded rendering.
          finalValue = this.stripAndCollapse(cur);
          if (curValue !== finalValue) {
            elem.setAttribute('class', finalValue);
          }
        }
      }
    }

    return this;
  }


  // Normalize the arguments to an array of strings
  // Allow for several class names like "a b, c" and several parameters
  args = (args: any, node: any, i: number) => {
    if (typeof args === 'function') {
      args = args(node, i);
    }
    if (typeof args !== 'string') {
      args = this.slice(args).map(this.str(node, i));
    }

    // Then convert that string to an array of not-null strings
    return args.toString().split(/[\s,]+/).filter((e: any) => {
      return e.length;
    });
  }
  str = (node: any, i: any) => {
    return (arg: any) => {
      // Call the function with the corresponding nodes
      if (typeof arg === 'function') {
        return arg.call(this, node, i);
      }

      // From an array or other 'weird' things
      return arg.toString();
    };
  }
  removeClass = (value?: any) => {
    let classes: Array<any>;
    let elem;
    let cur;
    let curValue: string;
    let clazz;
    let j;
    let finalValue;
    let i = 0;

    if (value === undefined) {
      this.nodes.forEach((el) => {
        el.attr('class', '');
      });
    } else {
      classes = this.classesToArray(value);

      if (classes.length) {
        // tslint:disable-next-line: no-conditional-assignment
        while ((elem = this.nodes[i++])) {
          curValue = this.getClass(elem);

          // This expression is here for better compressibility (see addClass)
          cur = elem.nodeType === 1 && (' ' + this.stripAndCollapse(curValue) + ' ');

          if (cur) {
            j = 0;
            // tslint:disable-next-line: no-conditional-assignment
            while ((clazz = classes[j++])) {

              // Remove *all* instances
              while (cur.indexOf(' ' + clazz + ' ') > -1) {
                cur = cur.replace(' ' + clazz + ' ', ' ');
              }
            }

            // Only assign if different to avoid unneeded rendering.
            finalValue = this.stripAndCollapse(cur);
            if (curValue !== finalValue) {
              elem.setAttribute('class', finalValue);
            }
          }
        }
      }
    }


    return this;
  }

  private stripAndCollapse = (val: any) => {
    const _token = val.match(this.rnothtmlwhite) || [];
    return _token.join(' ');
  }

  getClass = (elem: any) => {
    return elem.getAttribute && elem.getAttribute('class') || '';
  }

  hasClass = (selector: any) => {
    let className;
    let elem;
    let i = 0;
    className = ' ' + selector + ' ';
    // tslint:disable-next-line: no-conditional-assignment
    while ((elem = this.nodes[i++])) {
      if (elem.nodeType === 1 &&
        (' ' + this.stripAndCollapse(this.getClass(elem)) + ' ').indexOf(className) > -1) {
        return true;
      }
    }
    return false;
  }

  _siblings = (n: any, elem: any) => {
    const matched = [];

    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== elem) {
        matched.push(n);
      }
    }

    return matched;
  }

  siblings = (selector: any) => {
    return this.map((elem: any) => {
      return this._siblings((elem.parentNode || {}).firstChild, elem);
    }).filter(selector);

  }
  children = (selector: any) => {
    return this.map((node: any) => {
      return this.slice(node.children);
    }).filter(selector);

  }

  dir = (elem: any, dir: any) => {
    const matched = [];

    // tslint:disable-next-line: no-conditional-assignment
    while ((elem = elem[dir]) && elem.nodeType !== 9) {
      if (elem.nodeType === 1) {
        matched.push(elem);
      }
    }
    return matched;
  }

  _parent = (selector?: any) => {
    return this.map((elem: any) => {
      const parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    }).filter(selector, true);

  }

  parent = (selector?: any) => {
    return this.map((elem: any) => {
      const parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    }).filter(selector);

  }
  parents = (selector: any) => {
    const parents: Array<any> = [];
    return this.map((elem: any) => {
      parents.push(this.dir(elem, 'parentNode'));
      return parents;
    }).filter(selector);

  }

}

export const fnDom = new FnDomLibrary().init;
